module.exports = __webpack_public_path__ + "assets/img/24f8d536daff5b12f03723fa3c68dc7c.svg";